"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CreateAddressLoadingDockScanEvent200ResponseWarehouseIdEnum = void 0;
exports.CreateAddressLoadingDockScanEvent200ResponseWarehouseIdEnum = {
    NUMBER_null: null
};
//# sourceMappingURL=create-address-loading-dock-scan-event200-response.js.map